import { API_URL } from './Api';

export const API_URN = '/v1/delegacao-terceiro';

export function PERMISSIONARIO_PESQUISAR_ADM(idCorreios) {
  return {
    url: `${API_URL}${API_URN}/${idCorreios}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}
export function PERMISSIONARIO_PESQUISAR(idCorreios) {
  return {
    url: `${API_URL}${API_URN}/hierarquia/${idCorreios}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}
export function PERMISSIONARIO_PESQUISAR_IDCORREIOS(idCorreios) {
  return {
    url: `${API_URL}${API_URN}/meucorreios/${idCorreios}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}
export function PERMISSIONARIO_INCLUIR(body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/hierarquia`,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}

export function PERMISSIONARIO_EXCLUIR(idCorreios, lista, tipo, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/hierarquia/${idCorreios}/${tipo}`,
    options: {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(lista),
    },
  };
}
export function SISTEMA_AUTORIZADO_PERMISSIONARIO(body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/hierarquiaSistema`,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}
export function CONTRATO_AUTORIZADO_PERMISSIONARIO(body, ipAddress) {
  return {
    url: `${API_URL}${API_URN}/hierarquiaContrato`,
    options: {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Forwarded-For': ipAddress,
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
      body: JSON.stringify(body),
    },
  };
}
export function PERMISSIONARIO_PESQUISAR_SISTEMAS(idCorreios, idCorreiosPF) {
  return {
    url: `${API_URL}${API_URN}/hierarquiaSistema/${idCorreios}/${idCorreiosPF}`,
    options: {
      method: 'GET',
      headers: {
        Authorization: `Bearer ${window.localStorage.getItem('token')}`,
      },
    },
  };
}
